(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('NotificationSettingsController', NotificationSettingsController);

  /* ngInject */
  function NotificationSettingsController($state, Flash, assessmentEvents, contractEvents, documentRequirementEvents, globalNotificationService, notificationSettingsService, sessionService, vmsUserService) {
    const vm = this;

    vm.deleteGlobalNotification = deleteGlobalNotification;
    vm.fi = {};
    vm.globalNotifications = [];
    vm.notification = {};
    vm.notificationTypes = notificationTypes();
    vm.saveGlobalEventNotification = saveGlobalEventNotification;
    vm.updateSettings = updateSettings;
    vm.users = [];

    activate();

    function activate() {
      getGlobalNotifications();
      getNotificationSettings();
      getUsers();
    }

    function deleteGlobalNotification(globalNotification) {
      globalNotificationService(sessionService.getAuthToken()).destroy({ id: globalNotification.id }, _ => {
        $state.go('application.vms.notification_settings', {});
        Flash.create('success', 'Global notification successfully deleted.');
      }, _ => {
        Flash.create('danger', 'An unexpected error occurred. Please try again.');
      });
    }

    function getGlobalNotifications() {
      globalNotificationService(sessionService.getAuthToken()).query(response => vm.globalNotifications = response);
    }

    function getNotificationSettings() {
      notificationSettingsService(sessionService.getAuthToken()).get({}, response => vm.fi = response);
    }

    function getUsers() {
      vmsUserService(sessionService.getAuthToken()).query(response => vm.users = response);
    }

    function notificationTypes() {
      return assessmentEvents.concat(contractEvents).concat(documentRequirementEvents);
    }

    function saveGlobalEventNotification() {
      globalNotificationService(sessionService.getAuthToken()).create(vm.notification, _ => {
        $state.go('application.vms.notification_settings', {});
        Flash.create('success', 'Notification successfully created.');
      }, _ => {
        Flash.create('danger', 'An unexpected error occurred. Please try again.');
      });
    }

    function updateSettings() {
      notificationSettingsService(sessionService.getAuthToken()).update_settings(vm.fi, _ => {
        $state.reload();
        Flash.create('success', 'Notification settings successfully created.');
      }, _ => {
        Flash.create('danger', 'An unexpected error occurred. Please try again.');
      });
    }
  }
})();
